module.exports = __webpack_public_path__ + "img/Image7.c7b16424.jpg";